import React, { useEffect } from "react";
import s from "../styles/PolicyLayout.module.css";
import GradientBackgroundTerm from "../pages/home/GradientBackground_TERM";
import { buildSeoTitle } from "../utils/seoTitle";

function TermOfUseLayout({ title, appName, date, children }) {
  useEffect(() => {
    document.title = buildSeoTitle(appName, title);
  }, [appName, title]);

  return (
    <div className={s.pageWrapper}>
      <GradientBackgroundTerm />

      <div className={s.style}>
        <div className={s.central_text}>{title}</div>
        <div className={s.central_text_app_name}>{appName}</div>
        <div className={s.date}>{date}</div>

        <section className={s.policy_text}>{children}</section>
      </div>
    </div>
  );
}

export default TermOfUseLayout;
